export default "__VITE_ASSET__9fb66c4c__"